import { createContext } from 'react';
var AnalyticsNextContext = createContext({
    getAtlaskitAnalyticsContext: function () { return []; },
    getAtlaskitAnalyticsEventHandlers: function () { return []; },
});
export default AnalyticsNextContext;
